export default __webpack_public_path__ + "static/media/7.834b3905.jpg";